import Vue from 'vue';

export default {
  state: {
    fund: {},
    barGuide: {},
    action: {},
  },
  mutations: {
    updateCacheData(state, { value, key }) {
      Vue.set(state, key, value);
    },
    updateBarFistCacheData(state, { value, key }) {
      Vue.set(state.barGuide, key, value);
    },
  },
  actions: {
    updateCacheData({ commit }, nativeData) {
      return new Promise((resolve) => {
        commit('updateCacheData', {
          value: nativeData.value,
          key: nativeData.key,
        });
        resolve(nativeData);
      });
    },
    updateBarFistCacheData({ commit }, nativeData) {
      return new Promise((resolve) => {
        commit('updateBarFistCacheData', {
          value: nativeData.value,
          key: nativeData.key,
        });
        resolve(nativeData);
      });
    },
  },
  getters: {
    currentCacheBarInfo(state, getters, rootState) {
      return state.barGuide[rootState.native.fund.fundCode];
    },
  },
};
